import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useState, useRef, Fragment, useEffect } from "react";
import { DebounceInput } from "react-debounce-input";
import { useDispatch, useSelector } from "react-redux";
import { fetchInputListing, saveInputData, fetchInputsPopupData, tuningMultipleDelete, fetchCorrectionListing , fetchCorrectionPopupData , saveCorrectionData } from "../../redux/actions/chatAiActions";
import Loading from "../assetLibComponents/Loading";
import { ArrowLeft } from "react-bootstrap-icons/dist";
import { ExclamationTriangleIcon  } from "@heroicons/react/24/outline";
import ChatbotViewer from "./ChatbotViewer";
import { Dialog, Transition, Menu } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'
import TabTuning from "../TabTuning";
import  Happy  from "../../assets/zoi_happy.gif";
import SelectMenu from "./SelectMenu";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Toast from "../assetLibComponents/shared/Toast";

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const ChatTuning = (props) => {
  const inputListingRef = useRef();
  const correctionListingRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = props.authToken;
  const cancelButtonRef = useRef(null)
  const [selectedTuneListing, setSelectedTuneListing] = useState([]);
  const [open, setOpen] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [paginatedData, setPaginatedData] = useState([]);
  const [counter, setCounter] = useState(1);
  const [tabName, setTabName] = useState("Inputs");
  const [seconds, setSeconds] = useState(21);
  const [popupTitle, setPopupTitle] = useState("");
  const [testQuestion, setTestQuestion] = useState("");
  const [textResponse, setTextResponse] = useState("");
  const [deleteTuneId, setDeleteTuneId] = useState(null);
  const [inputTuningId, setInputTuningId] = useState(null);
  const [promptId, setPromptId] = useState(null);
  const [searchValue2, setSearchValue2] = useState("");
  const [originalResponseShow, setOriginalResponseShow] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [showPreviewer, setShowPreviewer] = useState(false);
  const [showCorrectionMode, setShowCorrectionMode] = useState(false);
  const [popupQuestion, setPopupQuestion] = useState([]);
  const [inputPaginatedData, setInputPaginatedData] = useState([]);
  const [correctionData, setCorrectionData] = useState(null); 
  const input_listing = useSelector((state) => state.chatAi.input_listing?.data);
  const total_count_input = useSelector((state) => state.chatAi.input_listing?.total);
  const correction_listing = useSelector((state) => state.chatAi.correction_listing?.data);
  const total_count = useSelector((state) => state.chatAi.correction_listing?.total);
  const isLoading = useSelector((state) => state.chatAi.loading);
  const total_page = Math.ceil(total_count / 10);
  const tabs = [
    { name: "Inputs", current: true },
    { name: "Corrections", current: false },
  ]
  
  const people = [
    { id: 1, name: 'Add Text' },
  ]
  
  const handleShowPreviewer = () => {
    setShowPreviewer(true);
    if (popupQuestion?.length === 0) {
      handleAddQuestion();
    }
  }
  
  const handleShowCorrector = () => {
    setShowCorrectionMode(true)
  }
  
  const handleAddWidget = (e) => {
    // setCurrentActivePage("add_c_q")
    if (e?.id === 1) {
      setPopupTitle("Add");
      setPromptId(null);
      handleShowPreviewer()
    } else {
      // addSingleTodo();
    }
  }
  
  const handleHidePreviewer = () => {
    setShowPreviewer(false);
    setInputTuningId(null);
    setTextResponse("");
    setPopupQuestion([]);
  }
  
  const deleteHandleClose = () => {
    setDeleteModal(false);
    setDeleteTuneId(null);
  };
  
  useEffect(() => {
    if (tabName !== "Inputs") {
      correctionListingRef?.current?.addEventListener('scroll', handleScroll);
      return () => {
        if (correctionListingRef?.current) {
          correctionListingRef?.current.removeEventListener('scroll', handleScroll);
        }
      };
    } else {
      inputListingRef?.current?.addEventListener('scroll', handleScroll);
      return () => {
        if (inputListingRef?.current) {
          inputListingRef?.current.removeEventListener('scroll', handleScroll);
        }
      };
    }
  }, [tabName]);
  
  useEffect(() => {
    setCounter(1);
    handleRemoveSearch2();
    if (tabName !== "Inputs") {
      // setCorrectionData(null);
    } else {
      setTestQuestion("");
    }
  }, [tabName])
  
  
  const handleScroll = async () => {
    const { scrollTop, clientHeight, scrollHeight } = tabName !== "Inputs" ? correctionListingRef.current : inputListingRef.current;
    
    if ((scrollTop + clientHeight) >= scrollHeight-1) {
      setCounter((prevPage) => prevPage + 1);
    }
  };
  
  useEffect(() => {
    if (tabName !== "Inputs") {
      if (counter <= total_page && counter !== 1) {
        callPaginationApi();
      }
    } else {
      if (counter <= total_count_input && counter !== 1) {
        callPaginationApi();
      }
    }
  }, [counter])
  
  const callPaginationApi = async () => {
    if (tabName !== "Inputs") {
      await dispatch(fetchCorrectionListing(props.authToken, "", counter, "pagination"));
    } else {
      await dispatch(fetchInputListing(props.authToken, "", counter, "pagination"));
    }
  }
  
  useEffect(() => {
    dispatch(fetchInputListing(props.authToken, "", counter, "normal"));
    dispatch(fetchCorrectionListing(authToken, "", 1, "normal"));
    let input_id = Cookies.get("p_id");
    let p_id = input_id?.slice(7);
    let type = input_id?.includes("HISTORY") ? "HISTORY" : "TRAINING"
    console.log("type", p_id, type);
    if (p_id && p_id != "null") {
      dispatch(fetchCorrectionPopupData(authToken, p_id, onSuccess, type));
    }
  }, [])
  
  const onSuccess = async (value, path) => {
    if (path !== "inputs") {
      setPopupTitle("Edit")
      setCorrectionData(value);
      setTextResponse(value?.new_answer);
      setTabName("Corrections")
      setShowCorrectionMode(true);
    } else {
      setPopupQuestion(value?.question);
      setInputTuningId(value?.id);
      setTextResponse(value?.answer);
      setTabName("Inputs");
      setShowPreviewer(true);
    }
    
  }
  
  const onSuccessTest = (value, path) => {
    if (path !== "inputs") {
      setPopupTitle("Edit")
      setCorrectionData(value);
      setTextResponse(value?.new_answer);
    } else {
      setPopupQuestion(value?.question);
      setInputTuningId(value?.id);
      setPromptId(value?.prompt_id);
      setTextResponse(value?.answer);
    }
  }
  
  useEffect(() => {
    if (counter > 1) {
      setPaginatedData((prevData) => [...prevData, ...correction_listing]);
    } else {
      setPaginatedData(correction_listing);
    }
  }, [correction_listing]);
  
  useEffect(() => {
    if (counter > 1) {
      setInputPaginatedData((prevData) => [...prevData, ...input_listing]);
    } else {
      setInputPaginatedData(input_listing);
    }
  }, [input_listing]);
  
  const handleRemoveSearch2 = (e) => {
    setSearchValue2("");
    if (tabName !== "Inputs") {
      dispatch(fetchCorrectionListing(authToken, "", 1,"normal"));
    } else {
      dispatch(fetchInputListing(authToken, "", 1,"normal"));
    }
  }
  
  const handleSearch2 = (e) => {
    if (e.target.value !== undefined) {
      setSearchValue2(e.target.value);
      if (tabName !== "Inputs") {
        dispatch(fetchCorrectionListing(authToken, e.target.value,1, "normal"));
      } else {
        dispatch(fetchInputListing(authToken, e.target.value,1, "normal"));
      }
      setCounter(1);
    }
  }
  
  const handleTuningCheckboxChange = (e,obj) => {
    if (e.target.id !== "anchor_heading") {
      if (selectedTuneListing.includes(obj)) {
        setSelectedTuneListing(selectedTuneListing.filter(item => item !== obj));
      } else {
        setSelectedTuneListing([...selectedTuneListing, obj]);
      }
    }
  };
  
  const handleUrlSelectAll = () => {
    setSelectedTuneListing(tabName !== "Inputs" ? paginatedData : inputPaginatedData)
  }
  
  const handleUrlUnSelectAll = () => {
    setSelectedTuneListing([])
  }
  
  const multipleDelete = (tuningDelete, path ) => {
    const arrayOfIds = tuningDelete.map(obj => obj.id);
    handleDelete(arrayOfIds, path);
  }

  const handleDelete = (deleteId, type) => {
    setDeleteModal(true)
    if (type === "single") {
      setDeleteTuneId({ id: [deleteId], type: type });
    } else {
      setDeleteTuneId({ id: deleteId, type: type });
    }
  };
    
  const chatOpenHandle = (value) => {
    setOpen(value);
  }
  
  const handleAddQuestion = () => {
    let addFlag = false;
    if (popupQuestion?.length > 0) {
      let newArr = [...popupQuestion];
      newArr.map((item) => {
        item.edit = false;
        if (item.question === "") {
          addFlag = true;
        }
        return item;
      })
    }
    
    if (addFlag === true) {
      return;
    }
    
    let newQuestion = {
      self_id: popupQuestion.length + 1,
      question: "",       
      edit: true
    }
    
    const addPerfectTodo = [...popupQuestion, newQuestion];
    setPopupQuestion(addPerfectTodo);
  }
  
  const handleQuestionValue = (value, ind) => {
    let newArr = [...popupQuestion];
    newArr.map((item,index) => {
      if (index === ind) {
        item.question = value;
        setTestQuestion(value);
      }
      return item;
    })
    setPopupQuestion(newArr);
  }

  const handleEditQuestion = (ind) => {
    let filteredArray = [];
    let newArr = [...popupQuestion];
    newArr.map((item, index) => {
      if (index === ind) {
        item.edit = true;
        setTestQuestion(item.question);
      } else {
        item.edit = false;
      }
      return item;
    })
    if (popupQuestion?.length > 0) {
      filteredArray = newArr.filter((item) => item.question !== "" )
    }
    setPopupQuestion(filteredArray);
  }
  
  const handleEditDeleteQuestion = (ind) => {
    let newArr = [...popupQuestion];
    let filteredArray = newArr.filter((arr, a_ind) => a_ind !== ind);
    filteredArray.map((item,index) => {
      if (index === filteredArray?.length - 1) {
        item.edit = true
        setTestQuestion(item.question);
      } else {
        item.edit = false
      }
      return item;
    })
    setPopupQuestion(filteredArray);
  }
  
  const handleDeleteQuestion = (ind) => {
    let newArr = [...popupQuestion];
    let filteredArray = newArr.filter((arr, a_ind) => {
      return a_ind !== ind
    });
    setPopupQuestion(filteredArray);
  }
  
  const wordCount = (str) => {
    const stringArray = str.split(" ");
    return stringArray?.length
  }
  
  useEffect(() => {
    if (buttonLoading === true) {
      const intervalId = setInterval(() => {
      setSeconds(prevSeconds => prevSeconds - 1);
      }, 1000); // Update every 1 second
      // Clear the interval when component unmounts
      return () => clearInterval(intervalId);
    }
  }, [buttonLoading]);

  return (
    <>
      {(isLoading) && <Loading />}
      <div>
        {/* Heading with Button */}
        <div className="flex justify-between mb-2 border-b border-gray-200 pb-4">
            <div className="text-lg leading-7 font-[500] my-auto">Fine Tuning</div>
            <div className="flex">
              {tabName === "Inputs" && <div className="mr-4">
                  <SelectMenu people={ people } handleAddWidget={handleAddWidget} />
              </div>}
              <button
                onClick={() => {
                  setCorrectionData(null);              
                  setOpen(true)
                }}
                type="button"
                className="inline-flex items-center gap-x-1.5 rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
              >
              <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" />
                Test ChatAI
              </button> 
            </div>            
        </div>
        {/* Input Field with Drag and drop Button */}
        {/* Listing Asset */}
        <div className={"overflow-hidden rounded-lg bg-white shadow mt-6"}>
          
          {/* Listing Heading With Search */}
          <div className="px-4 pt-2 sm:px-6 flex justify-between">
            <div className="text-base leading-6 font-semibold my-auto max-sm:w-full">
              <TabTuning tabs={tabs} setTabName={setTabName} tabName={tabName} />
            </div>
          </div>  
          <div className="border-b border-solid px-4 py-5 sm:px-6 flex justify-between">
            <div className="text-base leading-6 font-semibold my-auto">
                {tabName === "Inputs" ? "Added Text":"Corrections"}
            </div>
            <div className="relative rounded-md shadow-sm my-auto max-sm:w-[50%]">
              <DebounceInput
                value={searchValue2}
                className="block w-full rounded-md border-0 py-1.5 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[var(--brand-primary)] sm:text-sm sm:leading-6"
                placeholder="Search"
                minLength={3}
                debounceTimeout={500}
                onChange={handleSearch2}
              />
              <div className="absolute z-[9] cursor-pointer right-[5%] top-1/4">
                {searchValue2 && searchValue2 !== "" ? (
                    <Icon.X className="h-4 w-4 text-gray-400 pointer" onClick={handleRemoveSearch2} />
                  ) : (
                    <Icon.Search className="h-4 w-4 text-gray-400 cursor-pointer" onClick={handleSearch2} />
                  )}
              </div>
            </div> 
          </div>
            
          {/* Top Bar */}

          {selectedTuneListing.length > 0 && <div className="flex text-xs max-sm:m-auto items-center justify-between bg-[#F3F4F6]">
            <div className="flex text-xs max-sm:m-auto items-center w-full max-sm:w-auto justify-between max-sm:px-1 px-4 sm:px-6 max-sm:py-2 py-5 sm:p-1.5 bg-[#F3F4F6] border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)]">
              <div className="max-sm:hidden">{selectedTuneListing?.length} Selected</div>
              <div className="flex ml-auto mr-0 items-center">
                <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={() => { multipleDelete(selectedTuneListing, "multiple"); }}>
                      <Icon.Trash3 className="max-sm:hidden"/> <span>Delete</span>
                </div>
                <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={handleUrlUnSelectAll}>
                      <Icon.Subtract className="max-sm:hidden"/> <span>Unselect All</span>
                </div>
                <div className="hover:bg-[#D1D5DB] hover:border-[color-mix(in_srgb,var(--brand-primary)_10%,transparent)] border border-[#D1D5DB] flex flex-row justify-center items-center gap-1.5 bg-white not-italic font-bold text-xs leading-[15px] text-right text-[#374151] px-2.5 py-[5px] rounded-[6px] cursor-pointer ms-2 max-sm:ms-1" onClick={handleUrlSelectAll}>
                    <Icon.UiChecks className="max-sm:hidden"/> <span>Select All</span>
                </div>
              </div>
            </div>
          </div>}           
            
          {/* Listing Inputs */}
          {tabName === "Inputs" && <div className={(inputPaginatedData?.length > 0 ? "divide-y divide-gray-200 overflow-y-scroll listing ":"flex justify-center items-center ")+(selectedTuneListing.length > 0 ? "xl:h-[45vh] md:h-[40vh] h-[40vh] max-sm:h-[55vh]" : "xl:h-[50vh] md:h-[48vh] h-[48vh] max-sm:h-[60vh]")} ref={inputListingRef}>
            <div className="max-sm:w-[700px]">
              {inputPaginatedData?.length > 0 && inputPaginatedData.map((item, index) => {
                return(
                  <div className={"flex justify-between items-center px-4 sm:px-6 py-5 sm:p-4"}>
                    <div className="listing-check my-auto flex">
                      <input
                        type="checkbox"
                        className="me-2"
                        onChange={(e) => handleTuningCheckboxChange(e, item)}
                        checked={selectedTuneListing.includes(item)}
                      />
                    </div>
                    <span title={item?.answer} className="text-sm not-italic font-medium leading-5 w-[65%] max-sm:w-[50%] inline-block overflow-hidden text-ellipsis whitespace-nowrap ml-2.5">{item.answer}</span>
                    <div className="w-[35%] max-sm:w-[50%] flex justify-end items-center">
                      <span className="text-xs not-italic font-medium leading-4 inline-flex items-center rounded-md bg-gray-100 ml-4 max-sm:ml-1 px-2 py-1 text-gray-500 ring-1 ring-inset ring-gray-500/10">
                        {wordCount(item?.answer)} words
                      </span>
                      <span className="text-[rgba(33,33,33,0.30)] text-xs not-italic font-semibold mx-[25px] max-sm:mx-2 flex items-center cursor-pointer text-[12px] leading-3">
                        {item?.date?.slice(0,6)}
                      </span>
                      <Menu as="div" className="relative inline-block text-left">
                        <div>
                          <Menu.Button className="flex items-center rounded-full text-gray-400 focus:drop-shadow-none	focus:shadow-none focus-visible:drop-shadow-none focus-visible:shadow-none hover:text-gray-600 focus:outline-none focus:ring-0 focus:ring-white-500 focus:ring-offset-0 focus:ring-offset-white-100">
                            <span className="sr-only">Open options</span>
                            <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                          </Menu.Button>
                        </div>

                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 origin-bottom rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(index >= paginatedData?.length-3 && index > 2 ? " bottom-[30px]":"")}>
                            <div className="py-1">
                              <Menu.Item>
                                {({ active }) => (
                                  <span
                                    className={classNames(
                                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                      'block px-4 py-2 text-sm cursor-pointer'
                                    )}
                                    onClick={() => {
                                      setPromptId(item?.prompt_id);
                                      dispatch(fetchInputsPopupData(authToken, item.id, onSuccess));
                                      // handleShowPreviewer()
                                      setPopupTitle("Edit");
                                    }}
                                  >
                                    Edit
                                  </span>
                                )}
                              </Menu.Item>
                              <Menu.Item>
                                {({ active }) => (
                                  <span
                                    href="#"
                                    className={classNames(
                                      active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                      'block px-4 py-2 text-sm cursor-pointer'
                                    )}
                                    onClick={() => { handleDelete(item.id, "single") }}
                                  >
                                    Delete
                                  </span>
                                )}
                              </Menu.Item>
                            </div>
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                  </div>
                )
              })}
              {(inputPaginatedData?.length === 0) && (
                <div className="text-[rgba(33,33,33,0.3)] text-[17px] font-[bolder] text-center font-add">
                  <span className="flex justify-center text-[40px]">
                    <Icon.Inbox />
                  </span>
                  No Data
                </div>
              )}
              </div>
            </div>
          }
          
          {/* Listing Corrections */}
          {tabName !== "Inputs" && <div className={(paginatedData?.length > 0 ? "divide-y divide-gray-200 overflow-y-scroll listing ":"flex justify-center items-center ")+(selectedTuneListing.length > 0 ? "xl:h-[45vh] md:h-[40vh] h-[40vh] max-sm:h-[55vh]" : "xl:h-[50vh] md:h-[48vh] h-[48vh] max-sm:h-[60vh]")} ref={correctionListingRef}>
            <div className="max-sm:w-[700px]">
            {paginatedData?.length > 0 && paginatedData.map((item, index) => {
              return(
                <div className={item.editing !== true ? "flex justify-between items-center px-4 sm:px-6 py-5 sm:p-4":"flex justify-between px-4 sm:px-6 py-5 sm:py-[7px]"}>
                  <div className="listing-check my-auto flex">
                    <input
                      type="checkbox"
                      className="me-2"
                      onChange={(e) => handleTuningCheckboxChange(e, item)}
                      checked={selectedTuneListing.includes(item)}
                    />
                  </div>
                  <div className="grid w-[65%] text-gray-900 text-sm not-italic font-semibold ml-2.5">
                    <span>Question</span>
                    <span title={item?.question}>{item?.question}</span>
                  </div>
                  <div className="grid w-[65%] text-gray-500 text-sm not-italic font-medium ml-2.5">
                    <span className="font-semibold">Corrected Response</span>
                    <span title={item?.new_answer}>{item?.new_answer.length > 150 ? `${item?.new_answer?.slice(0,150)}...`: item?.new_answer}</span>
                  </div>
                  <div className="w-[35%] flex justify-end items-center">
                    <span className="text-[rgba(33,33,33,0.30)] text-xs not-italic font-semibold mx-[25px] max-sm:mx-2 flex items-center cursor-pointer text-[12px] leading-3">
                      {item?.date?.slice(0,6)}
                    </span>
                    <Menu as="div" className="relative inline-block text-left">
                      <div>
                        <Menu.Button className="flex items-center rounded-full text-gray-400 focus:drop-shadow-none	focus:shadow-none focus-visible:drop-shadow-none focus-visible:shadow-none hover:text-gray-600 focus:outline-none focus:ring-0 focus:ring-white-500 focus:ring-offset-0 focus:ring-offset-white-100">
                          <span className="sr-only">Open options</span>
                          <EllipsisVerticalIcon className="h-5 w-5" aria-hidden="true" />
                        </Menu.Button>
                      </div>

                      <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                      >
                        <Menu.Items className={"absolute right-0 z-10 mt-2 w-56 origin-bottom rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"+(index >= paginatedData?.length-3 && index > 2 ? " bottom-[30px]":"")}>
                          <div className="py-1">
                            <Menu.Item>
                              {({ active }) => (
                                <span
                                  className={classNames(
                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                    'block px-4 py-2 text-sm cursor-pointer'
                                  )}
                                  onClick={() => {
                                    setPopupTitle("Edit");
                                    onSuccess(item, "correction")
                                  }}
                                >
                                  Edit
                                </span>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <span
                                  href="#"
                                  className={classNames(
                                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                                    'block px-4 py-2 text-sm cursor-pointer'
                                  )}
                                  onClick={() => { handleDelete(item.id, "single") }}
                                >
                                  Delete
                                </span>
                              )}
                            </Menu.Item>
                          </div>
                        </Menu.Items>
                      </Transition>
                    </Menu>
                  </div>
                </div>
              )
            })}
            {(paginatedData?.length === 0) && (
              <div className="text-[rgba(33,33,33,0.3)] text-[17px] font-[bolder] text-center font-add">
                <span className="flex justify-center text-[40px]">
                  <Icon.Inbox />
                </span>
                No Data
              </div>
            )}
            </div>
          </div>
          }
        
        </div>

      {/* Correction Edit Mode    */}
      <Transition.Root show={showCorrectionMode} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleShowCorrector}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative h-[85vh] w-full max-sm:h-auto transform overflow-hidden rounded-lg bg-[#fff] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-4 sm:px-4">
                    {(seconds !== 0 && seconds < 20) && <>
                      <div className="bg-gray-500 cursor-auto opacity-25 absolute w-full left-0 right-0 text-black top-0 bottom-0 z-10 font-extrabold flex items-center justify-center"></div>
                        {(seconds > 14 && seconds < 20) && <span className="absolute flex left-0 right-0 text-[var(--brand-primary)] top-0 bottom-0 z-20 text-base font-medium items-center justify-center"><span className="flex items-center shadow-movement bg-white border-none shadow-[2px_12px_26px_#858585] pr-10 pl-6 py-[9px] rounded-[13px]"><img className="header-logo w-14 h-[3.5rem]" src={Happy} alt="Happy"/>Saving your text...</span></span>}
                        {(seconds > 7 && seconds < 15) && <span className="absolute flex left-0 right-0 text-[var(--brand-primary)] top-0 font-medium bottom-0 z-20 text-base items-center justify-center border"><span className="flex items-center shadow-movement bg-white shadow-[2px_12px_26px_#858585] pr-10 pl-6 py-[9px] rounded-[13px]"><img className="header-logo w-14 h-[3.5rem]" src={Happy} alt="Happy"/> Converting to embeddings...</span></span>}
                        {(seconds > 0 && seconds < 8) && <span className="absolute flex left-0 right-0 text-[var(--brand-primary)] font-medium top-0 bottom-0 z-20 text-base items-center justify-center"><span className="flex items-center shadow-movement bg-white shadow-[2px_12px_26px_#858585] pr-10 pl-6 py-[9px] rounded-[13px]"><img className="header-logo w-14 h-[3.5rem]" src={Happy} alt="Happy"/> Zoi is finalising your fine-tuning...</span></span>}
                    </>}
                    <div className="p-4 max-sm:p-1 ">
                    <div
                              onClick={() => {
                                setShowCorrectionMode(false);
                                setCorrectionData(null);
                                Cookies.set("p_id", null);
                                setTextResponse("");
                              }}
                              type="button"
                              className="ml-auto flex cursor-pointer"
                            >
                              <Icon.X className="ml-auto text-2xl mb-2 text-gray-500 rounded-xl outline-none ring-white outline-white"/>
                            </div> 
                      <div className="flex justify-between mb-3 border-b border-gray-200 pb-4">
                          <div className="text-lg leading-7 font-[500] my-auto">{popupTitle}</div>
                          <div className="flex gap-2">
                            <button
                            onClick={() => {
                              if (textResponse === "" || textResponse === null ) {
                                Toast("Please fill the corrected response","E")
                                return;
                              }
                              setButtonLoading(true);
                              let input_id, type;
                                input_id = Cookies.get("p_id");
                              if (input_id && input_id != "null") {  
                                type = input_id?.includes("HISTORY") ? "HISTORY" : "TRAINING";
                              } else {
                                type = correctionData?.conversation_type;
                              }
                                dispatch(saveCorrectionData(authToken, correctionData, textResponse, type, "test", onSuccessTest));
                                setTimeout(() => {
                                  setSeconds(21);
                                  setButtonLoading(false);
                                }, 21000);
                              }}
                              type="button"
                              className="inline-flex items-center justify-center gap-x-1.5 hover:bg-[#D1D5DB] hover:border-[rgba(83,85,86,0.1)] border border-[#D1D5DB] w-[100px] bg-transparent not-italic font-bold text-[14px] text-center text-[#374151] px- py-[5px] rounded-[6px] cursor-pointer relative bg-white shadow-sm sm:text-sm sm:leading-6"
                            >
                              Save
                            </button> 
                            <button
                              onClick={() => {
                                  setOpen(true);
                              }}
                              type="button"
                              className="inline-flex gap-1 rounded-md bg-[var(--brand-primary)] px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                            >
                              <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" /> Test
                            </button> 
                          
                            
                          </div>            
                      </div>
                      <div>
                        <div>
                          <p className="w-full py-2.5 cursor-pointer text-gray-900 text-2xl not-italic font-semibold leading-8">{`Q. ${correctionData?.question}`}</p>
                        </div>
                        
                        <div className="flex flex-col justify-center items-start gap-0.5 self-stretch">
                          <p className="text-gray-700 flex gap-1 items-center text-xs not-italic font-semibold leading-4">{originalResponseShow !== true ? <Icon.ArrowDownShort className="cursor-pointer text-lg" onClick={()=>{setOriginalResponseShow(true)}}/>:<Icon.ArrowUpShort className="cursor-pointer text-lg" onClick={()=>{setOriginalResponseShow(false)}}/>}Original AI Response</p>
                          {originalResponseShow !== false && <p className="text-gray-700 max-h-[25vh] listing overflow-y-auto text-sm not-italic font-normal leading-5">{ correctionData?.old_answer }</p>}
                        </div>
                        
                        {/* <div className="w-full flex items-center justify-start">
                          <a
                            href="/Conversation"
                            // onClick={() => {
                            //   Cookies.set("conversation_data", "item.id ");
                            // }}
                            target="blank"
                            className="my-2 text-sm hover:text-[#59d0e5] text-[var(--brand-primary)] cursor-pointer"
                          >
                            View Full Conversation
                          </a>
                        </div> */}
                        
                        <div className="mt-4 p-[3px] rounded-md pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-[var(--brand-primary)]">
                          <label htmlFor="name" className="block px-3 text-xs not-italic font-medium leading-4 text-gray-900">
                            Corrected Response
                          </label>
                          <textarea
                            rows={6}
                            name="comment"
                            id="comment"
                            className="block text-sm not-italic listing font-normal leading-5 w-full resize-none rounded-md border-none py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-0 focus:ring-inset sm:text-sm sm:leading-6"
                            value={textResponse}
                            onChange={(e) => {
                              setTextResponse(e.target.value)
                            }}
                            placeholder="Enter Response.."
                          />
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
      </Transition.Root>        

      {/* Input Edit Mode    */}
      <Transition.Root show={showPreviewer} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleShowPreviewer}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative h-[85vh] w-full max-sm:h-auto transform overflow-hidden rounded-lg bg-[#fff] px-4 pb-4 pt-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:py-4 sm:px-4">
                    {(seconds !== 0 && seconds < 20) && <>
                      <div className="bg-gray-500 cursor-auto opacity-25 absolute w-full left-0 right-0 text-black top-0 bottom-0 z-10 font-extrabold flex items-center justify-center"></div>
                        {(seconds > 14 && seconds < 20) && <span className="absolute flex left-0 right-0 text-[var(--brand-primary)] top-0 bottom-0 z-20 text-base font-medium items-center justify-center"><span className="flex items-center shadow-movement bg-white border-none shadow-[2px_12px_26px_#858585] pr-10 pl-6 py-[9px] rounded-[13px]"><img className="header-logo w-14 h-[3.5rem]" src={Happy} alt="Happy"/>Saving your text...</span></span>}
                        {(seconds > 7 && seconds < 15) && <span className="absolute flex left-0 right-0 text-[var(--brand-primary)] top-0 font-medium bottom-0 z-20 text-base items-center justify-center border"><span className="flex items-center shadow-movement bg-white shadow-[2px_12px_26px_#858585] pr-10 pl-6 py-[9px] rounded-[13px]"><img className="header-logo w-14 h-[3.5rem]" src={Happy} alt="Happy"/> Converting to embeddings...</span></span>}
                        {(seconds > 0 && seconds < 8) && <span className="absolute flex left-0 right-0 text-[var(--brand-primary)] font-medium top-0 bottom-0 z-20 text-base items-center justify-center"><span className="flex items-center shadow-movement bg-white shadow-[2px_12px_26px_#858585] pr-10 pl-6 py-[9px] rounded-[13px]"><img className="header-logo w-14 h-[3.5rem]" src={Happy} alt="Happy"/> Zoi is finalising your fine-tuning...</span></span>}
                    </>}
                    <div className="max-sm:p-1 px-4">
                      <div className="flex flex-col justify-between mb-3 border-b border-gray-200 pb-4">
                      <div
                            onClick={() => {
                              handleHidePreviewer();
                              setTestQuestion("");
                              setTextResponse("");
                            }}
                            type="button"
                            className="cursor-pointer"
                          >
                            <Icon.X className="text-2xl mb-2 ml-auto text-gray-500 rounded-xl"/>
                          </div> 
                          <div className="flex justify-between">
                        <div className="text-lg leading-7 font-[500] my-auto">{popupTitle}</div>
                        <div className="flex gap-2">
                          <button
                            onClick={() => {
                              let flag = false;
                              popupQuestion?.map((item) => {
                                if (item.question === "") {
                                  flag = true;
                                }
                                return item;
                              })
                              
                              if (flag === true || textResponse === "" || textResponse === null) {
                                Toast("Please fill the question and response","E")
                                return;
                              }
                              flag = false;
                              setButtonLoading(true);
                              const arrayOfQuestion = popupQuestion?.map((item) => {
                                if (item.edit === true) {
                                  setTestQuestion(item.question);
                                }
                                let obj = { question: item.question }
                                return obj;
                              })
                              dispatch(saveInputData(authToken, inputTuningId, promptId, arrayOfQuestion, textResponse, "test", onSuccessTest));
                              setTimeout(() => {
                                setSeconds(21);
                                setButtonLoading(false);
                              }, 21000);
                            }}
                            type="button"
                            className="inline-flex items-center justify-center gap-x-1.5 hover:bg-[#D1D5DB] hover:border-[rgba(83,85,86,0.1)] border border-[#D1D5DB] w-[100px] bg-transparent not-italic font-bold text-[14px] text-center text-[#374151] px- py-[5px] rounded-[6px] cursor-pointer relative bg-white shadow-sm sm:text-sm sm:leading-6"
                          >
                            Save
                          </button> 
                          <button
                            onClick={() => {
                                setOpen(true);
                            }}
                            type="button"
                            className="inline-flex gap-1 rounded-md bg-[var(--brand-primary)] px-5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-primary)]"
                          >
                           <ArrowLeft className="-ml-0.5 h-5 w-5" aria-hidden="true" /> Test
                          </button> 
                          </div>
                        </div>            
                      </div>
                      <div>
                        {popupQuestion?.length > 0 && <div className="xl:max-h-[40vh] pb-2 md:max-h-[32vh] max-h-[34vh] max-sm:max-h-[35vh] overflow-y-auto listing pr-1">
                          {popupQuestion?.length > 0 && popupQuestion?.map((quest, q_index) => {
                            return (
                              <div className={"mt-2 relative rounded-md px-3 pr-10 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-[var(--brand-primary)] "+(quest.edit === true ? "pb-1.5 py-2.5":"")}>
                                {quest.edit === true ? <>
                                  <label htmlFor="name" className="block text-xs font-medium text-gray-900">
                                    Enter Question
                                  </label>
                                  <input
                                    type="text"
                                    name="question"
                                    id="question"
                                    value={quest.question}
                                    onChange={(e) => {
                                      handleQuestionValue(e.target.value, q_index);
                                    }}
                                    autoFocus
                                    className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6"
                                    placeholder="Question here.."
                                  />
                                  {popupQuestion?.length > 1 && <Icon.Trash onClick={()=>{handleEditDeleteQuestion(q_index)}} className="absolute -translate-y-2/4 top-2/4 right-2 text-base text-gray-600 cursor-pointer"/>}
                                </>
                                :
                                <>
                                  <p onClick={()=>{handleEditQuestion(q_index)}} className="w-full py-2.5 cursor-pointer text-base font-medium">{quest.question}</p>
                                    {popupQuestion?.length > 1 && <Icon.Trash onClick={() => { handleDeleteQuestion(q_index) }} className="absolute -translate-y-2/4 top-2/4 right-2 text-base text-gray-600 cursor-pointer" />}
                                </>
                                }
                              </div>
                            );
                          })}
                        </div>}
                        <div className="w-full flex items-center justify-end">
                          {popupQuestion.length < 5 ? <p className="my-2 text-right text-xs hover:text-[#59d0e5] text-[var(--brand-primary)] cursor-pointer" onClick={()=>{if(popupQuestion?.length < 5){handleAddQuestion()}}}>+ Add Similar Question</p>:
                          <p className="inline-flex items-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 my-2 text-right" onClick={()=>{if(popupQuestion?.length < 5){handleAddQuestion()}}}>You have reached your questions limit</p>}
                        </div>
                        
                        <div className="mt-4 p-[3px] rounded-md pt-2.5 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-[var(--brand-primary)]">
                          <label htmlFor="name" className="block px-3 text-xs font-medium text-gray-900">
                            Enter Response
                          </label>
                          <textarea
                            rows={6}
                            name="comment"
                            id="comment"
                            className="block w-full resize-none rounded-md listing border-none py-1.5 text-gray-900 shadow-sm placeholder:text-gray-400 focus:ring-0 focus:ring-inset sm:text-sm sm:leading-6"
                            value={textResponse}
                            onChange={(e) => {
                              setTextResponse(e.target.value)
                            }}
                            placeholder="Text Here.."
                          />
                        </div>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
      </Transition.Root>

      {/* Delete Modal   */}
      <Transition.Root show={deleteModal} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={deleteHandleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 z-10 overflow-y-auto">
              <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                      <div className="sm:flex sm:items-start">
                        <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                          <ExclamationTriangleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                        </div>
                        <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                          <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                            Delete {tabName !=="Inputs"?"Correction(s)":"Input(s)"}
                          </Dialog.Title>
                          <div className="mt-2">
                            <p className="text-sm text-gray-500">
                               Are you sure you want to delete the selected {tabName !=="Inputs"?"correction(s)":"input(s)"}?
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                      <button
                        type="button"
                        className="inline-flex w-full justify-center rounded-md bg-[var(--brand-primary)] px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-[color-mix(in_srgb,var(--brand-primary)_82%,white)] sm:ml-3 sm:w-auto"
                        onClick={async () => {
                          await dispatch(tuningMultipleDelete(authToken, deleteTuneId?.id , deleteTuneId?.type, tabName ))
                          setCounter(1);
                          setSelectedTuneListing([]);
                          deleteHandleClose();
                        }}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                        onClick={() => deleteHandleClose(false)}
                        ref={cancelButtonRef}
                      >
                        No
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        <ChatbotViewer authToken={props.authToken} open={open} chatOpenHandle={chatOpenHandle} autoQuestion={correctionData?.question || testQuestion || ""} />
      </div>
    </>
  );
};

export default ChatTuning;
